/** Chizilgan imzoning chegarasi — bo'sh maydon bo'lsa `null`. */
export interface InkBounds {
  x: number;
  y: number;
  width: number;
  height: number;
}

/**
 * IMZONING HAQIQIY chegarasi — atrofidagi bo'sh joysiz.
 *
 * Odam katak o'rtasiga kichkina chizadi, chetlari esa bo'sh qoladi. O'sha
 * bo'shliq bilan birga saqlansa, hujjatdagi katakka sig'dirilganda imzo
 * mitti bo'lib qolardi: kataknig balandligini bo'sh piksellar egallardi.
 *
 * Shaffoflik bo'yicha qaraladi (`alpha`), rang bo'yicha emas: fon shaffof va
 * qora ham, ko'k ham, qalam rangi o'zgarsa ham qoida bir xil qoladi.
 *
 * `data` — `ImageData.data` shakli: har piksel uchun to'rt bayt (RGBA).
 */
export const inkBounds = (
  data: Uint8ClampedArray | readonly number[],
  width: number,
  height: number,
): InkBounds | null => {
  let minX = width;
  let minY = height;
  let maxX = -1;
  let maxY = -1;

  for (let y = 0; y < height; y += 1) {
    for (let x = 0; x < width; x += 1) {
      // Alfa — pikselning to'rtinchi bayti.
      const alpha = data[(y * width + x) * 4 + 3] ?? 0;
      if (alpha === 0) continue;
      if (x < minX) minX = x;
      if (x > maxX) maxX = x;
      if (y < minY) minY = y;
      if (y > maxY) maxY = y;
    }
  }

  if (maxX < 0) return null;
  return { x: minX, y: minY, width: maxX - minX + 1, height: maxY - minY + 1 };
};

/**
 * Chegaraga NAFAS qo'shadi va rasmdan chiqib ketmasligini ta'minlaydi.
 *
 * Nafassiz qirqilgan imzo katakning chekkasiga yopishib turadi va bosilganda
 * qo'shni chiziqqa tegib ketgandek ko'rinadi.
 */
export const padBounds = (
  bounds: InkBounds,
  padding: number,
  width: number,
  height: number,
): InkBounds => {
  const x = Math.max(0, bounds.x - padding);
  const y = Math.max(0, bounds.y - padding);
  return {
    x,
    y,
    width: Math.min(width - x, bounds.width + padding * 2),
    height: Math.min(height - y, bounds.height + padding * 2),
  };
};
